import { render, staticRenderFns } from "./line_LJ.vue?vue&type=template&id=13b85118&scoped=true&"
import script from "./line_LJ.vue?vue&type=script&lang=js&"
export * from "./line_LJ.vue?vue&type=script&lang=js&"
import style0 from "./line_LJ.vue?vue&type=style&index=0&id=13b85118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b85118",
  null
  
)

export default component.exports